export const ACCEPT_EXTERNAL_INFO = "ACCEPT_EXTERNAL_INFO";
export const ACCEPT_SALES_INFO = "ACCEPT_SALES_INFO";
export const ACCEPT_NEWSLETTER = "ACCEPT_NEWSLETTER";
export const EMPLOYEE_ENTRY = "EMPLOYEE_ENTRY";
